<template>
  <div id="category">
    <div class="">
      <van-search
        v-model:value="condition"
        show-action
        placeholder="请输入商品名称"
        @search="toSearch"
        @clear="clear"
      >
        <template #right-icon>
          <van-icon name="scan" @click="toScan"></van-icon>
        </template>
        <template #action>
          <div @click="toSearch">搜索</div>
        </template>
      </van-search>
    </div>

    <div class="listWrapper">
      <div class="leftWrapper">
        <MenuSideBar
          ref="menuSidebar"
          :menuData="categories"
          :activeId="query.categoryId"
          @toggleChildren="clickLeft"
        />
      </div>
      <div class="rightWrapper">
        <GlobalLoading :show="loading || cateLoading" />
        <div v-if="categoriesDetail && categoriesDetail.length">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="已显示全部"
            :immediate-check="false"
            @load="onLoad"
            :offset="50"
            class="productWrapper"
          >
            <div v-for="(cate, index) in categoriesDetail" :key="cate.id">
              <div class="categoryTitle fs14">{{ cate.name }}</div>
              <van-card
                v-for="(item, index) in getList(cate.products)"
                :key="(item.id || item.productId) + index"
                :desc="formatDesc(item)"
                :price="formatePrice(item)"
                :title="item.name || item.productName"
                @click="toDetail(item.id || item.productId)"
                :thumb="
                  item.picture ||
                  'https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg'
                "
              >
                <template #footer v-if="type !== 'search'">
                  <van-button
                    size="normal"
                    @click="modifyProduct($event, item)"
                    class="fs14"
                    v-if="type === 'edit'"
                    >编辑</van-button
                  >
                  <div
                    v-else-if="type && type.includes('purchase')"
                    class="cart"
                    @click.stop=""
                  >
                    <div
                      v-if="item[numKey]"
                      class="numChangeBox"
                      @click.stop=""
                    >
                      <van-icon
                        class="circleIcon"
                        name="minus"
                        @click="minus($event, item, index)"
                      />
                      <van-field
                        class="numInput"
                        autocomplete="off"
                        type="number"
                        v-model="item[numKey]"
                        @change="inputChange($event, item, index)"
                      >
                      </van-field>
                      <van-icon
                        class="circleIcon"
                        name="plus"
                        @click="plus($event, item, index)"
                      />
                    </div>
                    <van-icon
                      v-else
                      name="shopping-cart-o"
                      size="20"
                      color="#4c9673"
                      @click="plus($event, item, index)"
                    />
                  </div>
                </template>
              </van-card>
            </div>
          </van-list>
        </div>
        <div v-else-if="!loading" class="emptyWrapper">暂无商品</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/header/Header";
import { mapMutations, mapState } from "vuex";
import { reqWeightCategory, reqCategoryItems } from "../../service/api/product";
import { queryPurchaseProductList } from "../../service/api/purchase/order";
import GlobalLoading from "@/components/globalLoading";
import ProductItem from "./components/productItem/ProductItem";
import { buildTree } from "../../utils";
import MenuSideBar from "@/components/menuSideBar/index";
import _ from "lodash";
import axios from "axios";
export default {
  name: "Category",
  categories: Array,
  code: null,
  data() {
    return {
      // 左侧列表数组
      categories: [{ id: 0, name: "全部" }],
      categoriesDetail: [],
      currentIndex: 0,
      query: {
        name: "",
        pageIndex: 1,
        pageSize: 20,
        available: true,
        categoryId: "",
      },
      condition: "",
      cateLoading: false,
      loading: false, // 滚动加载中
      finished: false, // 滚动加载完成
      ordering: { tableData: [] },
      productsBySort: [],
      showPicker: false,
      formData: {
        updatePrice: 0,
      },
      name: "",
      numKey: "purchaseNum",
      storageOrdering: {},
      type: "",
    };
  },
  components: {
    Header,
    GlobalLoading,
    ProductItem,
    MenuSideBar,
  },
  computed: {
    ...mapState(["shopCart", "userInfo"]),
  },
  watch: {
    ordering: {
      handler(newVal) {
        if (newVal && newVal.scId) {
          localStorage.setItem(this.orderingKey, JSON.stringify(newVal));
        }
      },
      deep: true,
    },
  },
  created() {
    try {
      this.condition = localStorage.getItem("searchScanText") || "";
    } catch (error) {
      this.condition = "";
    }
  },
  mounted() {
    this.type = this.$route.query.type;
    this.condition = this.$route.query.name || "";
    this.getRes();
    this.orderingKey = this.type + "ing";
    if (this.type === "purchaseOrder") {
      this.numKey = "purchaseNum";
    } else if (this.type === "purchaseReturn") {
      this.numKey = "returnNum";
    } else if (this.type === "purchaseReceive") {
      this.numKey = "receiveNum";
    }
    this.storageOrdering = JSON.parse(
      localStorage.getItem(this.orderingKey) || "{}"
    );
    this.ordering = JSON.parse(localStorage.getItem(this.orderingKey) || "{}");
    const queryForm = JSON.parse(localStorage.getItem("queryForm") || "{}");
    this.ordering = Object.assign({ tableData: [] }, this.ordering, queryForm);
  },
  methods: {
    getList(list) {
      return list.map((el) => {
        const item = { ...el };
        const orderingItem = this.ordering?.tableData?.find(
          (t) => t.productId === item.productId
        );
        if (orderingItem) {
          return { ...item, ...orderingItem };
        }
        return item;
      });
    },
    formatDesc(item) {
      return "商品条码：" + (item.externalCode || "--");
    },
    handleQuantityUpdate(item, index, newValue) {
      newValue = Math.max(Number(newValue) || 0, 0);
      const productId = item.productId;
      this.$set(item, this.numKey, newValue);
      const dataIndex = this.ordering.tableData.findIndex(
        (t) => t.productId === productId
      );

      if (dataIndex > -1) {
        if (newValue > 0) {
          // 使用 Vue 的响应式机制更新数组元素
          this.$set(this.ordering.tableData, dataIndex, {
            ...this.ordering.tableData[dataIndex],
            [this.numKey]: newValue,
          });
        } else {
          // 删除数组元素时，确保数组不为空

          this.ordering.tableData.splice(dataIndex, 1);
        }
      } else if (dataIndex <= -1 && newValue > 0) {
        this.ordering.tableData.unshift(this.createOrderItem(item, newValue));
      }
    },
    createOrderItem(item, quantity) {
      return Object.assign(
        {},
        {
          description: "",
          productionDate: "",
          shelfLifeDays: "0",
          shelfLife: "",
        },
        item,
        { [this.numKey]: quantity }
      );
    },
    inputChange(event, item, index) {
      event.stopPropagation();
      const value = event.target.value;
      if (value !== "" && !isNaN(value)) {
        this.handleQuantityUpdate(item, index, value);
      }
    },
    minus(event, item, index) {
      event.stopPropagation();
      const current = Number(item[this.numKey] || 0);
      const newValue = this.$utils.preciseSubtraction(current, 1);
      this.handleQuantityUpdate(item, index, newValue);
    },
    plus(event, item, index) {
      debugger;
      event.stopPropagation();
      const current = Number(item[this.numKey] || 0);
      const newValue = this.$utils.preciseAdd(current, 1);
      this.handleQuantityUpdate(item, index, newValue);
    },
    formatePrice(item) {
      const unit = item.unit ? "/" + item.unit : "";
      if (this.type && this.type.includes("purchase")) {
        return String(item.purchasePrice).includes(".")
          ? item.purchasePrice + unit
          : item.purchasePrice + ".00" + unit;
      } else {
        return String(item.retailPrice).includes(".")
          ? item.retailPrice + unit
          : item.retailPrice + ".00" + unit;
      }
    },
    modifyProduct(e, row) {
      console.log("modifyProduct", row, this.query, this.condition);
      e.preventDefault();
      this.$router.push(
        "/product/modify/" +
          (row.id || row.productId) +
          "?categoryId=" +
          this.query.categoryId +
          "&name=" +
          this.condition
      );
    },
    toDetail(id) {
      if (!this.type || this.type === "edit") {
        return;
      }
      localStorage.setItem(
        "productDetail-preRoute",
        JSON.stringify({
          path: "/product/category",
          query: { type: `${this.type}` },
        })
      );
      this.$router.push({
        path:
          "/productDetail/" +
          id +
          "?categoryId=" +
          this.query.categoryId +
          "&name=" +
          this.condition,
      });
    },
    addDays(date, days) {
      if (!date || !days) {
        return "";
      }
      const result = new Date(date);
      result.setDate(result.getDate() + Number(days));
      return moment(result).format("YYYY-MM-DD");
    },
    ...mapMutations(["ADD_GOODS"]),
    clear() {
      localStorage.setItem("searchScanText", "");
    },
    toScan() {
      this.$router.push({
        name: "qrcodeScan",
      });
    },
    toSearch() {
      console.log(this.query, "toSearch");
      document.documentElement.scrollTop = 0;
      this.query.pageIndex = 1;
      if (this.$refs?.menuSidebar && this.$refs.menuSidebar.setActiveId) {
        this.$refs.menuSidebar.setActiveId(null);
        this.query.categoryId = "";
      }
      console.log(this.query, "toSearch2");
      this.search(false);
    },
    onLoad() {
      this.query.pageIndex++;
      this.search(true);
    },
    async search(isLoadMore = false) {
      if (!isLoadMore) {
        this.query.pageIndex = 1; // 重置分页索引
        this.categoriesDetail = []; // 清空数据
        this.finished = false; // 重置加载完成状态
      }
      this.loading = true;

      try {
        // 提取公共逻辑到单独函数
        this.updateQuery(isLoadMore);

        let rightRes;
        if (this.type && this.type.includes("purchase")) {
          rightRes = await queryPurchaseProductList(this.query);
        } else {
          rightRes = await reqCategoryItems(this.query);
        }

        if (rightRes.code !== 200) {
          this.loading = false;
          return;
        }
        // 使用 Map 提高查找效率
        const categoryMap = new Map([]);
        const data = rightRes.data.datas;
        data.forEach((item) => {
          item.desc = item.desc ? item.desc : item.unit ? "/" + item.unit : "";

          let categoryId = item.categoryId;
          if (!categoryMap.has(categoryId)) {
            categoryMap.set(categoryId, {
              id: categoryId,
              name: item.categoryName,
              products: [item],
            });
          } else {
            categoryMap.get(categoryId).products.push(item);
          }
        });

        if (isLoadMore) {
          this.categoriesDetail.forEach((cate) => {
            categoryMap.set(cate.id, cate);
          });
          this.categoriesDetail = [
            ...this.categoriesDetail,
            ...Array.from(categoryMap.values()),
          ];
        } else {
          this.categoriesDetail = Array.from(categoryMap.values());
        }

        if (this.query.pageIndex >= rightRes.data.totalPage) {
          this.finished = true;
        }
        this.loading = false;
      } catch (error) {
        if (error.isCanceled) return;
        this.loading = false;
      }
      this.$forceUpdate();
    },

    updateQuery(isLoadMore) {
      if (!isLoadMore) {
        this.query.pageIndex = 1; // 重置分页索引
      }
      this.query.condition = this.condition;

      const queryForm = JSON.parse(localStorage.getItem("queryForm") || "{}");
      if (
        this.condition ||
        this.query.categoryId ||
        !this.type.includes("purchase")
      ) {
        this.query = Object.assign({}, this.query, {
          scId: queryForm.scId,
        });
      } else {
        this.query = Object.assign({}, this.query, {
          scId: queryForm.scId,
          supplierId: queryForm.supplierId,
        });
      }
    },

    async getRes() {
      this.categories = [];
      this.cateLoading = true;
      reqWeightCategory()
        .then(async (res) => {
          if (res.code == 200) {
            const data = res.data;
            this.categories = [{ id: 0, name: "全部" }].concat(buildTree(data));
            if (this.$route.query.categoryId) {
              // 直接调用menuSidebar的setActiveId方法
              if (
                this.$refs.menuSidebar &&
                this.$refs.menuSidebar.setActiveId
              ) {
                this.$refs.menuSidebar.setActiveId(
                  this.$route.query.categoryId
                );
              }
              this.clickLeft(this.$route.query.categoryId);
            } else {
              // 默认不自动选中，除非用户点击
              // 如果需要默认选中"全部"，可以取消下面这行注释
              // this.query.categoryId = "";
              this.search(false);
            }
          }
        })
        .finally(() => {
          this.cateLoading = false;
        });
    },
    async clickLeft(id) {
      document.documentElement.scrollTop = 0;
      this.query.pageIndex = 1;
      this.finished = false;
      if (this.query.categoryId === id) {
        return;
      }
      if (id == 0) {
        this.query.categoryId = "";
      } else {
        this.query.categoryId = id;
      }
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
#category {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  overflow: hidden;
  padding-top: 46px;
}

.listWrapper {
  display: flex;
  position: absolute;
  top: 93px;
  bottom: 46px;
  width: 100%;
  overflow: hidden;
  height: calc(100vh - 100px);

  .leftWrapper {
    background-color: #f4f4f4;
    height: 100%;
    width: 5.2rem;
    .categoryItem {
      padding: 0.75rem 0;
      border-bottom: solid 1px #e8e9e8;
      position: relative;
    }

    .categoryItem .textWrapper {
      width: 100%;
      display: inline-block;
      line-height: 1.25rem;
      border-left: solid 0.1875rem transparent;
      padding: 0.3125rem 0.6875rem;
      font-size: 0.675rem;
      color: #666666;
    }

    .categoryItem.selected {
      background: #fff;
    }

    .categoryItem.selected .textWrapper {
      border-left-color: #0960bd;
      font-weight: bold;
      font-size: 0.675rem;
      color: #333333;
    }

    @media (min-width: 960px) {
      .wrapper {
        border-right: 1px solid #e8e9e8;
      }

      .wrapper .categoryItem {
        background: #fff;
      }
    }
  }

  .rightWrapper {
    overflow-y: auto;
    height: calc(100% - 46px);
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    position: absolute;
    left: 5.3125rem;
    right: 0;
    bottom: 0;
    top: 0;
    background: #fff;
    .emptyWrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .categoryTitle {
      padding: 0 0.3125rem;
      height: 1.25rem;
      line-height: 1.25rem;
      font-size: 0.75rem;
      background: #f8f8f8;
      color: #666666;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

::v-deep .van-card__title {
  font-size: 17px;
  max-height: 50px;
  min-height: 43px;
  line-height: 20px;
  padding: 0px !important;
  overflow: hidden !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.cart {
  height: 35px;
}
.numChangeBox {
  width: 150px;
  float: right;
  background: #fafafa;
  align-items: center;
  .numInput {
    font-weight: 600;
    color: #000;
    width: 100px;
    padding: 2px 0 0 10px;
  }
}
</style>
